define.alias("shared/components/shared/restricted-area/body", "media/components/shared/restricted-area/body");